import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  animations: [
    trigger('rowState', [
      transition(':enter', [
        style({opacity: 0}),
        animate('.25s', style({opacity: 1}))
      ])
    ])
  ]
})
export class TableComponent {

  @ContentChild(TemplateRef)rowTemplate;

  @Input() template: TemplateRef<any>;
  @Input('data')data = [];
  @Input('columns')columns = [];

  constructor() { }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/table/table.component.ts